import * as R from 'remeda';
import { createSelector } from 'reselect';
import Types from 'Types';
import { jwtUtility } from 'utility';
import { JwtFeature } from 'utility/jwt';

const domain = (state: Types.RootState) => state.glue.user;

const bearerToken = createSelector(domain, (domain) => domain.bearerToken);

// Path to navigate to after the OIDC callback resolves. Read by SigninOidcPage,
// then cleared via setPostLoginRedirect(null) once consumed.
const postLoginRedirect = createSelector(
  domain,
  (domain) => domain.postLoginRedirect,
);

const parsedToken = createSelector(bearerToken, (token) => {
  if (!R.isDefined(token)) return undefined;
  return jwtUtility.parseJwt(token);
});

const tenantId = createSelector(parsedToken, (token) => {
  if (!R.isDefined(token)) return null;
  return token.tenant_id;
});

// All feature flags carried by the active token. Empty when the token is
// missing or carries no `feature` claim.
const features = createSelector(parsedToken, (token) => token?.feature ?? []);

// Selector factory — produces a selector that resolves to `true` when the
// active token includes the given feature. Used by route guards via
// store.getState() and by the navigation menu via useSelector().
// const hasFeature = (feature: JwtFeature) =>
//   createSelector(features, (features) => features.includes(feature));

const hasFeature = createSelector(
  (_state: Types.RootState, ownProps: { feature: JwtFeature }) =>
    ownProps.feature,
  features,
  (feature, features) => features.includes(feature),
);

export {
  bearerToken,
  features,
  hasFeature,
  parsedToken,
  postLoginRedirect,
  tenantId,
};
